import React from "react";
import * as moment from "moment";

import Arrowup from "../../../assets/Arrowup.svg";
import PayDetails from "../PayDetails";
import "./Paycard.css";
import { Util } from "./../../../../../../helpers/util";

const Paycard = ({ payouts }) => {
  const { currency } = Util.getCurrency();
  return (
    <div className="pay-session">
      <div className="paycardSession">
        <div>
          <p className="paytext">Payout</p>
        </div>
      </div>
      <div className="payDetails">
        {payouts.map((payout) => {
          return (
            <PayDetails
              key={payout.id}
              icon={Arrowup}
              title={"Withdraw to Bank"}
              date={moment(payout.created_at).format("MMM DD, YYYY")}
              amount={`- ${currency} ${Util.formatMoneyNumber(payout.amount)}`}
              style={{
                color: " #EE5253",
              }}
            />
          );
        })}
      </div>
    </div>
  );
};

export default Paycard;
